import { render } from "./CreateOrderStatus.vue?vue&type=template&id=00b47b6b&scoped=true"
import script from "./CreateOrderStatus.vue?vue&type=script&lang=js"
export * from "./CreateOrderStatus.vue?vue&type=script&lang=js"

import "./CreateOrderStatus.vue?vue&type=style&index=0&id=00b47b6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b47b6b"]])

export default __exports__